<template>
  <div>
    <!-- Main content -->
    <section class="content newsweekly">
      <div class="row">
        <div class="col-xs-6 center-box">
          <div class="box">
            <div class="box-header">
              <h3 class="box-title">News Weekly</h3>
            </div>
            <!-- /.box-header -->
            <div class="box-body table-responsive no-padding">
              <table class="table table-hover">
                <tbody>
                  <tr>
                    <th>Date</th>
                    <th class="td-right">Action</th>
                  </tr>
                  <tr v-for="item in list" v-bind:key="item.id">
                    <td>{{item.date}}</td>
                    <td>
                      <button
                        class="btn btn-info btn-sm btn-agent-edit pull-right"
                        data-toggle="modal"
                        v-on:click="handleDownload(item)"
                      >Download</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
      </div>
    </section>
    <!-- /.content -->

    <!-- Generate -->
    <div class="add-app-bgcolor dropup" v-if="isAdminInApp">
      <button class="add-app-btn" v-on:click="handleCreate">
        <span class="btn add-app">
          <i class="fa fa-plus"></i>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import utils from "../../utils";
import store from "../../store";

const genMarkdownFile = function genMarkdownFile(data) {
  const { title, date, todoList, doneList, fixedList, styleHrefs } = data;
  const table = (caption, list, defaultDue = "待定") => `
    <h2 style="font-size: 24px; margin: 40px 0 20px;">${caption}</h2>
    <table class="table">
      <thead style="background: #f7f7f7;">
        <tr>
          <th>标题</th>
          <th style="width: 100px;">完成时间</th>
        </tr>
      </thead>
      <tbody>
        ${list
          .map(
            issue => `
            <tr>
              <td>${issue.title}</td>
              <td style="width: 100px;">${issue.due_date || defaultDue}</td>
            </tr>
          `
          )
          .join("\n")}
      </tbody>
    </table>
  `;

  const content = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>${title}</title>
        ${styleHrefs
          .map(href => `<link rel="stylesheet" href="${href}" />`)
          .join("\n")}
      </head>
      <body style="background: ghostwhite;">
        <div
          style="max-width: 960px; margin: auto; padding: 2em; background: white; box-shadow: 0 0 3px rgba(0,0,0,0.2);"
        >
          <h1 style="margin-bottom: 1em;">${title}</h1>
          ${table("进行中", todoList)}
          <hr class="hr" />
          ${table("正在验证", doneList)}
          <hr class="hr" />
          ${table("已完成", fixedList, date)}
        </div>
      </body>
    </html>
  `;

  const fragment = document.createElement("a");
  const blob = new Blob([content]);
  fragment.href = URL.createObjectURL(blob);
  fragment.target = "_blank";
  fragment.download = `${title}.html`;
  fragment.click();
};

export default {
  name: "din-news-weekly",
  data() {
    return {
      list: []
    };
  },
  computed: {
    isAdminInApp() {
      return utils.checkIsAppAdmin();
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      const list = await api.post({
        path: "/dinnewsweekly/get?_type=json",
        withLoading: true
      });
      this.list = list;
    },
    async handleCreate() {
      const { ok } = await api.post({
        path: "/dinnewsweekly/create?_type=json",
        withLoading: true
      });
      if (!ok) {
        store.commit("SET_ERROR", "Create News Weekly failed.");
      } else {
        await this.fetch();
      }
    },
    async handleDownload({ id }) {
      const data = await api.post({
        path: "/dinnewsweekly/getone?_type=json",
        data: { id },
        withLoading: true
      });
      console.log("data", data);
      const { date, doneList, fixedList } = data;
      const title = `${date} 周报`;
      const todoList = [...data.todoList, ...data.doingList];
      const { origin } = location;
      const bootstrapCSSHref = origin + "/static/css/bootstrap.min.css";
      genMarkdownFile({
        title,
        date,
        todoList,
        doneList,
        fixedList,
        styleHrefs: [bootstrapCSSHref]
      });
    }
  }
};
</script>

<style scoped>
.newsweekly .center-box {
  margin: auto;
  float: none;
}
.newsweekly th,
.newsweekly td {
  padding-left: 2em;
  padding-right: 2em;
}
.newsweekly .td-right {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// DinNewsWeekly.vue?27a0c543